// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a1ffa95e","239":"e97618ff","455":"426d4315","947":"8ec94508"}[chunkId] + ".chunk.js";
};